angular.module('olivioConfiguratorApp').factory('OLIVIOMainFactory', function ($rootScope, Data, Model) {

  /**OLIVIO.Main*/ var current = null;

  var service = {
    /**
     * create new OLIVIO.Main with all the side effects from the library :)<br />
     *     and remember it
     * @param{Object} scope   $scope of calling controller
     * @returns{OLIVIO.Main} new created OLIVIO.Main
     * */
    create: function (scope) {
      console.log('\n>>> creating new OLIVIO.Main'+(current!==null?' and destroying exsting!':'')+'\n');
      if (current)
        current.destroy();
      current = new OLIVIO.Main(Model.model, Data, scope);
      return current;
    },
    /** destroy remembered OLIVIO.Main with side effects, ie. unregister Mouse Events <br /> and forget it */
    destroy: function () {
      if (current != null)
        current.destroy();
      current = null;
    },
    /** getCurrent OLIVIO.Main if there's one
     * @returns{OLIVIO.Main} previously created OLIVIO.Main if there's one */
    getCurrent: function()
    {
      return current;
    }
  };

  return service;
});
